import CustomColumnDisplay from "@components/Common/CustomColumnDisplay";
import { customColumnProps } from "@maherunlocker/custom-react-table";
import { t } from "i18next";
import React from "react";
import { CustomIcons } from "./CustomIcons";

export function getCustomColumns({
    setShopId,
    setRowData,
    setSale,
    setDataIsUpdated,
    setSelectedRows,
    isModeOfSaleArchived,
    setSelectName,
    setSelectSales,
    setInputSaleMode,
    selectedRows,
    setLocalFilterActive,
    setIsConsult,
    setDataState,
    setSalesModesTypesAndTag,
    setFormState,
    isConsult,
    setSalesSupport,
    setTagsData,
    modalState,
    setModalState,
}: any): customColumnProps[] {
    return [
        {
            indexOFColumn: 0,
            columnName: t("Display name"),
            customJsx: (e: any) => (
                <CustomColumnDisplay text={e.selectedRow.display_name} />
            ),
            filterName: "display_name",
            canFilter: true,
        },
        {
            indexOFColumn: 1,
            columnName: t("Sales method"),
            customJsx: (e: any) => <span>{e.selectedRow["Mode of sale"]}</span>,
            filterName: t("Sales method"),
            canFilter: true,
        },
        {
            indexOFColumn: 2,
            columnName: t("Sale support"),
            customJsx: (e: any) => (
                <CustomColumnDisplay
                    text={e.selectedRow.support_vente.join()}
                />
            ),
            filterName: "support_vente",
            canFilter: true,
        },
        {
            indexOFColumn: 3,
            columnName: t("Tag"),
            customJsx: (e: any) => (
                <CustomColumnDisplay text={e.selectedRow.tag.join()} />
            ),
            filterName: "tag",
            canFilter: true,
        },
        {
            indexOFColumn: 7,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    e={e}
                    setShopId={setShopId}
                    setRowData={setRowData}
                    setSale={setSale}
                    setDataIsUpdated={setDataIsUpdated}
                    setSelectedRows={setSelectedRows}
                    isOneShop={true}
                    isModeOfSaleArchived={isModeOfSaleArchived}
                    setSelectName={setSelectName}
                    setSelectSales={setSelectSales}
                    setInputSaleMode={setInputSaleMode}
                    selectedRows={selectedRows}
                    setLocalFilterActive={setLocalFilterActive}
                    setIsConsult={setIsConsult}
                    setDataState={setDataState}
                    setSalesModesTypesAndTag={setSalesModesTypesAndTag}
                    setFormState={setFormState}
                    isConsult={isConsult}
                    setSalesSupport={setSalesSupport}
                    setTagsData={setTagsData}
                    modalState={modalState}
                    setModalState={setModalState}
                />
            ),
            disableFilter: false,
        },
    ];
}
